import React from "react";
import {autorun} from "mobx";
import EsriFeature from "@arcgis/core/widgets/Feature";

import {UiState} from "../../../../ui-state";

import {PopupConfiguration} from "../../../../config/popup-configuration";
import {observer} from "mobx-react";
import {MapViewerConfiguration} from "../../../../../config/map-viewer-configuration";
import {Button} from "semantic-ui-react";
import {ActionButtonConfiguration} from "../../../../config/action-configuration";
import {Icon} from "../../../icon/icon";
import {PopupPanelActionOea} from "../popup-panel-actions/popup-panel-action-oea";
import * as arcade from "@arcgis/core/arcade";
import EsriGraphic from "@arcgis/core/Graphic";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import {AppConfiguration} from "../../../../config/app-configuration";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import {PathUtils} from "../../../../../utils/path-utils";
import {AppState} from "../../../../../components/app/app-mobx";

interface PopupItemProps {
    appConfig: AppConfiguration;
    config: PopupConfiguration;
    mapViewerConfig: MapViewerConfiguration;
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    graphic: __esri.Graphic;
    popup: any;
    uiStore: UiState;
    index: number;
    panel: any;
}
@observer
export class PopupPanelItem extends React.Component<PopupItemProps, any> {
    watchHandles: any[] = [];
    popup: any;
    popupItemRef: any;
    index: number;
    constructor(props: PopupItemProps) {
        super(props);
        this.popupItemRef = React.createRef();
        this.state = {
            viewModel: null,
            title: false,
            isLoading: true,
            profileIsLoding: false
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }
    componentDidMount(): void {
        const {graphic, view, popup} = this.props;
        autorun((reaction: any) => {
            if (!view) {
                return;
            }
            if (!popup) {
                return;
            }
            const featureChild = new EsriFeature({
                container: this.popupItemRef.current,
                graphic,
                map: view.map,
                defaultPopupTemplateEnabled: true,
                spatialReference: view.spatialReference,
                visibleElements: { title: false }
            });
            this.watchHandles.push(featureChild.watch("title", (title) => {
                this.setState({title});
            }));
            this.watchHandles.push(featureChild.viewModel.watch("waitingForContent", (waitingForContent) => {
                if (!waitingForContent) {
                    if (featureChild.title !== this.state.title) {
                        this.setState({title: featureChild.title});
                    }
                    // wird für eine allfällige Neupositionierung des Popups verwendet
                    popup.setState({lastItemTitle: featureChild.title});
                }
            }));
            reaction.dispose();
        });
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    handleButtonClick(e: React.MouseEvent, action: ActionButtonConfiguration): void {
        const {graphic, view, appStore} = this.props;
        if (!view) {
            return;
        }
        if (typeof action.id !== "undefined") {
            if (action.id === "gravis") {
                window.open(action.url +
                    "Suche.Gemeinde="
                    + (graphic.attributes.BFS_NR? graphic.attributes.BFS_NR: graphic.attributes.bfs_nr)
                    + "&FOCUS=" + view.center.x + ":" + view.center.y + ":" + view.scale,
                "gravis");
            } else if (action.id === "oereb") {
                window.open(action.url +
                    "oereb.htm?EGRID="
                    + (graphic.attributes.EGRIS_EGRID? graphic.attributes.EGRIS_EGRID: graphic.attributes.egris_egrid),
                "oereb");
            } else if (action.id === "objekt") {
                window.open(action.url + ""
                    + (graphic.attributes.EGRIS_EGRID? graphic.attributes.EGRIS_EGRID: graphic.attributes.egris_egrid),
                "objekt");
            } else if (action.id === "selection") {
                if (graphic.attributes.UUID_OBJEKT) {
                    appStore.api.featureSelectionComplete(action.query?.id, graphic.attributes.UUID_OBJEKT);
                }
                else {
                    appStore.api.featureSelectionError("Selected object has no UUID_OBJEKT attribute");
                }
            } else if (action.id === "link") {
                const profile: __esri.Profile = {
                    variables: [{
                        name: "$feature",
                        type: "feature"
                    }]
                };
                if(action.url) {
                    const actionUrl = action.url?.indexOf("`") > -1 ? action.url : "`" + action.url + "`";
                    const arcadeExecutor = arcade.createArcadeExecutor(actionUrl, profile);
                    arcadeExecutor.then((ae) => {
                        const link = ae.execute({
                            $feature: graphic
                        });
                        window.open(link, "link");
                    });
                } else {
                    console.warn("Keine URL definiert!");
                }
            } else if (action.id === "profile") {
                this.props.uiStore.setActiveTool("profile", graphic);
            } else if (action.id === "profile_query") {
                const queryConfig = action.query;
                if(queryConfig) {
                    this.setState({profileIsLoding: true});
                    let searchLayer: FeatureLayer | __esri.Sublayer | __esri.MapImageLayer | undefined;
                    // sourceLayer on Graphic is not documented!
                    if ("sourceLayer" in graphic){
                        searchLayer = (graphic as any).sourceLayer;
                        if(searchLayer.hasOwnProperty("layer") && searchLayer.hasOwnProperty("id")
                            && queryConfig.hasOwnProperty("layerId") && queryConfig.layerId !== searchLayer?.id){
                            searchLayer = (searchLayer as __esri.Sublayer).layer as __esri.MapImageLayer;
                        }
                    } else if (queryConfig.id === "self"
                        && queryConfig.hasOwnProperty("portalItem")) {
                        const layerConfig = {
                            layerType: "feature",
                            layerId: (queryConfig.layerId) ? queryConfig.layerId : undefined,
                            portalItem: queryConfig.portalItem,
                            opacity: 1,
                            listMode: "hide",
                            legendEnabled: false,
                            title: (queryConfig.title) ? queryConfig.title : undefined
                        };
                        searchLayer = new FeatureLayer(layerConfig as __esri.FeatureLayerProperties);
                    }else{
                        console.warn("Keine gültiger Layer für Query definiert!");
                    }
                    if(searchLayer) {
                        searchLayer.load().then((v) => {
                            if(searchLayer.hasOwnProperty("allSublayers")) {
                                searchLayer = v.allSublayers.find((sublayer: __esri.Sublayer) =>
                                    sublayer.id === queryConfig.layerId);
                            }
                            if (searchLayer) {
                                const profile: __esri.Profile = {
                                    variables: [{
                                        name: "$feature",
                                        type: "feature"
                                    }]
                                };
                                const arcadeExecutor = arcade.createArcadeExecutor(queryConfig.expression, profile);
                                arcadeExecutor.then((ae) => {
                                    let where = ae.execute({
                                        $feature: graphic
                                    });
                                    if (typeof where === "string" && searchLayer) {
                                        // definitionExpression in Suche berücksichtigen, falls diese definiert ist.
                                        if (searchLayer.definitionExpression) {
                                            where = "(" + where + ") AND (" + searchLayer.definitionExpression + ")";
                                        }
                                        const query = searchLayer.createQuery();
                                        query.where = where;
                                        searchLayer.queryFeatures(query)
                                            .then((response: __esri.FeatureSet) => {
                                                if (response.features.length === 0) {
                                                    console.warn("Kein Profil Resultat gefunden");
                                                    return;
                                                }
                                                let geometry: __esri.Geometry;
                                                if (response.features.length > 1) {
                                                    const geometries: __esri.Geometry[] = [];
                                                    response.features.forEach((item) => {
                                                        geometries.push(item.geometry);
                                                    });
                                                    geometry = geometryEngine.union(geometries);
                                                } else {
                                                    geometry = response.features[0].geometry;
                                                }
                                                const featureGraphic = new EsriGraphic({
                                                    geometry,
                                                    symbol: this.props.appConfig.search.resultSymbol?.line
                                                });
                                                this.props.uiStore.setActiveTool("profile", featureGraphic);
                                                this.setState({profileIsLoding: false});
                                                if (this.props.view) {
                                                    this.props.view.graphics.push(
                                                        featureGraphic
                                                    );
                                                    const fullExtent = featureGraphic.geometry.extent.clone();
                                                    fullExtent.expand(1.5);
                                                    this.props.view?.goTo(fullExtent).catch((error) => {
                                                        if (error.name !== "view:goto-interrupted") {
                                                            // eslint-disable-next-line no-console
                                                            console.error(error);
                                                        }
                                                    });
                                                }
                                            });
                                    }
                                });
                            }
                        });
                    }
                } else {
                    console.warn("Keine Query definiert!");
                }
            } else {
                // TODO: Bei nächsten API Update überprüfen ob es wieder mit der ESRI trigger-action funktioniert
                // popup.popup.viewModel.triggerAction(popup.actionMap[action.id]);
                const event = new CustomEvent("geo-trigger-action", {detail: action});
                window.dispatchEvent(event);
            }
        }
    }
    render(): JSX.Element | null {
        const { title } = this.state;
        const {config, graphic, popup, panel, index} = this.props;
        // const activePage = popup.state.activePages[panelIndex];
        if (!popup) {
            return null;
        }
        const activePage = panel.state.activePage;
        const visible = (activePage === index);
        this.index = index;
        let contentClass = "geo-feature";
        if (popup.state.selectedPanelIndex === panel.index && visible) {
            contentClass += " geo-feature-selected";
        }
        if (visible) {
            contentClass += " geo-feature-show";
        } else {
            contentClass += " geo-feature-hide";
        }
        const buttonsTop: JSX.Element[] = [];
        const buttons: JSX.Element[] = [];
        if (title !== false) {
            let buttonCount = 0;
            if (config.dockEnabled) {
                buttonsTop.push(<Button
                    compact
                    icon
                    size="mini"
                    key={"button-" + buttonCount}
                    onClick={(e: React.MouseEvent) =>
                        this.props.popup.handleZoomInClick(e, panel.props.index, index)}>
                    <Icon name={"zoom_in"} />
                </Button>);
            }else{
                buttons.push(<Button
                    compact
                    size="mini"
                    key={"button-" + buttonCount}
                    onClick={(e: React.MouseEvent) =>
                        this.props.popup.handleZoomInClick(e, panel.props.index, index)}>
                    <Icon name={"zoom_in"} /> Zoomen
                </Button>);
            }
            buttonCount++;
            // sourceLayer on Graphic is not documented!
            const source = (graphic as any).sourceLayer;
            let popupTemplate: __esri.PopupTemplate | null = null;
            if (source) {
                popupTemplate = (source as __esri.Sublayer).popupTemplate;
                // parsedUrl on Layer is not documented!
                let url = (source as any).parsedUrl?.path;
                if (!url) {
                    url = source.url; // MapImageLayer Service
                }
                if (typeof url === "string") {
                    let metauid = PathUtils.getMetaId(url);
                    const layerId = PathUtils.getLayerId(url);
                    if(metauid){
                        metauid = PathUtils.slug(metauid);
                        contentClass+=" "+metauid;
                        if (typeof layerId === "number"){
                            contentClass+=" "+metauid+"-"+layerId;
                        }
                    }
                }
            }
            if (popupTemplate && popupTemplate.actions) {
                popupTemplate.actions.forEach((actionConfig) => {
                    if(actionConfig.id==="oea"){
                        buttons.push(<PopupPanelActionOea
                            key={"button-" + buttonCount}
                            size="mini"
                            actionConfig={actionConfig as ActionButtonConfiguration}
                            graphic={graphic}>
                        </PopupPanelActionOea>);
                    } else {
                        buttons.push(<Button
                            compact
                            size="mini"
                            key={"button-" + buttonCount}
                            className={actionConfig.className
                                + ((actionConfig.id==="profile_query" && this.state.profileIsLoding)?
                                    " geo-profile-loading": "")}
                            onClick={(e: React.MouseEvent) =>
                                this.handleButtonClick(e, actionConfig as ActionButtonConfiguration)}>
                            {actionConfig.icon && <Icon name={(actionConfig as ActionButtonConfiguration).icon}/>}
                            {actionConfig.id==="profile_query" && <Icon
                                name={"recycle"} className={"geo-rotating"}/>} {actionConfig.title}
                        </Button>);
                    }
                    buttonCount++;
                });
            }
        }
        return (
            <div className={contentClass}
                onClick={(e: React.MouseEvent) => this.props.popup.handleHighlightClick(e, panel.props.index, index)}
                onMouseEnter={(e: React.MouseEvent) =>
                    this.props.popup.handleHighlightClick(e, panel.props.index, index)}>
                {(buttonsTop.length>0)?
                    <div className="geo-action-buttons geo-action-buttons-top">
                        {buttonsTop}
                    </div>: null}
                <div ref={this.popupItemRef}/>
                {(buttons.length>0)?
                    <div className="geo-action-buttons geo-action-buttons-bottom">
                        {buttons}
                    </div>: null}
            </div>
        );
    }
}
